import { useEffect } from "react";
import { useLatestRef } from "@design-system/hooks/useLatestRef";

export const SPRING_LOAD_DELAY_MS = 400;

/** Calls `onActivate` once something has stayed hovered for `delayMs`; leaving earlier cancels it. */
export function useHoverActivation({
    isOver,
    onActivate,
    delayMs = SPRING_LOAD_DELAY_MS,
}: {
    isOver: boolean;
    onActivate: () => void;
    delayMs?: number;
}) {
    const onActivateRef = useLatestRef(onActivate);

    useEffect(() => {
        if (!isOver) {
            return;
        }
        const timeoutId = window.setTimeout(
            () => onActivateRef.current(),
            delayMs,
        );
        return () => window.clearTimeout(timeoutId);
    }, [isOver, delayMs, onActivateRef]);
}
